import { Action } from '@ngrx/store';

export const DELETE_EXTRACT_SUCCESS = '[Extract] Delete Extract Success';

export class DeleteExtractSuccessAction implements Action {
  readonly type = DELETE_EXTRACT_SUCCESS;
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/DeleteExtractSuccessAction.ts